module.exports = __webpack_public_path__ + "static/media/xareLogo_transparent.0ed3d559.png";